import $ from "jquery";

class MainMenu {
  constructor() {
    this.sidebar = $('.sidebar');
    this.toggler = $('.menu-toggle');
    this.menu = $('.sitemenu');
    this.openToggler = $('.open-menu-toggle');
    this.closedToggler = $('.closed-menu-toggle')
    this.events();
  }

  events() {
    this.toggler.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleMenu();
    })

    $(window).on('click', () => {
      this.closeMenu();
    });

    this.menu.on('click', (e) => {
      e.stopPropagation();
    })

    this.sidebar.on('click', (e) => {
      e.stopPropagation();
      this.closeMenu();
    })
  }
  toggleMenu() {
    if(this.toggler.hasClass('open-menu')) {
      this.openToggler.hide();
      this.closedToggler.show();
    } else {
      this.openToggler.show();
      this.closedToggler.hide();
    }
    this.menu.toggleClass('open-menu');
    this.toggler.toggleClass('open-menu');
  }
  closeMenu() {
    this.menu.removeClass('open-menu');
    this.toggler.removeClass('open-menu');
    this.openToggler.hide();
    this.closedToggler.show();
  }
}

new MainMenu();